import { useMemo } from 'react';
import { Table } from 'redesign';
import { useTranslation } from 'react-i18next';
import { getDepartmentsColumnDefinition } from './get-departments-column-definition';
import { getDepartmentsTableData } from './get-departments-table-data';

export const Departments = ({ departments }: { departments: string[] }) => {
  const { t } = useTranslation('ogp-screen-specific');
  const columns = useMemo(() => getDepartmentsColumnDefinition(t), []);
  const tableData = useMemo(() => getDepartmentsTableData(departments), [departments]);

  return <Table stickyHeader data={tableData} columns={[columns.name]} />;
};
